import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.ends-with.js";
import { mapState } from "vuex";
import moment from "moment";
import MessageModal from "@/components/common/MessageModal.vue";
import StudentSelector from "@/components/messages/StudentSelector.vue";
import PreviewModal from "@/components/messages/PreviewModal";
import InputEnquete from "@/components/common/InputEnquete.vue";
import LoadingMessage from "@/components/common/LoadingMessage";
import ConfirmModal from "@/components/common/ConfirmModal";
import RowItem from "@/components/RowItem";
import { createData, getData, updateData } from "@/services/axios";
var __default__ = {
  name: "CreateMessage",
  components: {
    RowItem: RowItem,
    MessageModal: MessageModal,
    StudentSelector: StudentSelector,
    InputEnquete: InputEnquete,
    LoadingMessage: LoadingMessage,
    ConfirmModal: ConfirmModal,
    PreviewModal: PreviewModal
  },
  data: function data() {
    return {
      pageTitle: "お知らせ作成",
      s3_attached_path: false,
      getS3UrlStatus: "内容を確認",
      getS3UrlStatusRunning: false,
      messageTemplates: [],
      messageSentResult: true,
      error: {
        total: null,
        sendTargets: null,
        subject: null,
        mail_body: null,
        call_body: null,
        enquete: null,
        attachment: null
      },
      id: false,
      isLoading: {
        status: true,
        message: false,
        postData: false
      },
      loadingMessage: "",
      callBodyInput: false,
      targetEnqueteId: false,
      showConfirmModal: false,
      showPreviewModal: false,
      showStudentSelectModal: false,
      showCompleteModal: false,
      confirmMessageTitle: "",
      confirmMessage: "",
      targetFunction: "",
      processReviewing: false,
      approvalModeActive: false,
      originalStatus: null,
      requesterName: "",
      confirmMode: false,
      is_switch_visibility: true
    };
  },
  head: {
    title: function title() {
      return {
        inner: this.pageTitle
      };
    },
    meta: []
  },
  computed: _objectSpread(_objectSpread({}, mapState(["capabilities", "me", "enquete", "school"])), {}, {
    isApprovalTarget: function isApprovalTarget() {
      return this.originalStatus === "reviewing" && (this.me.role_id <= 11 || this.school.meta && this.school.meta.allowNoSignatureMessaging);
    }
  }),
  watch: {
    "$route.params.id": function $routeParamsId() {
      this.$router.go();
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.id = this.$route.params.id;

      if (this.id) {
        this.pageTitle = "お知らせ編集";
      }

      this.setData();
    },
    setData: function setData() {
      var _this = this;

      getData("messages/templates").then(function (data) {
        _this.messageTemplates = data.items;
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this.isLoading.status = false;
      }); // params に targets が来てたら送信先を選択済みとする

      if (this.$route.params.targets) {
        this.message.sendTargets = this.$route.params.targets;
      } // IDが渡っている = 編集モード = データを取り出す


      if (this.id) {
        getData("reader/get_message_detail/" + this.$route.params.id).then(function (data) {
          var status = data.items.message.status; // 承認リンク経由で開いたが、既に他の管理者が処理済みだった場合は結果を案内する

          if (_this.$route.query.show_approval_modal && status !== "reviewing") {
            _this.showAlreadyProcessedModal(status);

            return;
          }

          if (status === "reserved" || status === "published") {
            _this.$router.push({
              name: "messages"
            });
          }

          _this.setSavedData(data.items);

          if (_this.$route.query.show_message_status) {
            _this.confirmTo();
          }

          if (_this.$route.query.show_approval_modal && _this.isApprovalTarget) {
            _this.openApprovalModal();
          }
        }).catch(function (error) {
          console.log(error); // axiosのresponseが存在するエラーの時は一覧に戻る
          // if (error.response) {
          //   this.$router.push({ name: "messages" });
          // }
        });
      } else {
        // id がない = 新規 = storeリセット
        this.$store.dispatch("commitEnquete", {
          subject: "",
          implement_to: "",
          questions: [{
            subject: "",
            options: [""],
            type: "single"
          }]
        }); // params に content が来てたら本文や添付、アンケートをコピー

        if (this.$route.params.content) {
          this.message.subject = this.$route.params.content.subject;
          this.message.mail_body = this.$route.params.content.mail_body;
          this.message.call_body = this.$route.params.content.call_body; // 添付ファイル

          if (this.$route.params.content.attached_file) {
            this.s3_attached_path = this.message.attached_file = this.$route.params.content.attached_file;
          }
        }

        if (this.$route.params.questions && this.$route.params.enquete_subject) {
          this.message.useEnquete = true;
          var questions_data = [];
          this.$route.params.questions.forEach(function (v) {
            questions_data.push({
              subject: v.subject,
              options: v.options,
              type: v.type
            });
          });
          this.$store.dispatch("commitEnquete", {
            subject: this.$route.params.enquete_subject,
            questions: questions_data
          });
        }
      }
    },

    /**
     * DBから入力済みのデータを取り出す
     *
     * @param data
     */
    setSavedData: function setSavedData(data) {
      // 送信先
      this.message.sendTargets = {
        students: data.targets.students,
        participants: data.targets.participants
      }; // 緊急配信

      this.message.is_emergency = data.message.is_emergency; // 予約日時

      this.message.message_scheduled_for = data.message.message_scheduled_for; // 有効期限

      this.message.expire_on = data.message.expire_on; // 共有範囲

      this.message.visibility = data.message.visibility; // 共有範囲変更権限

      this.is_switch_visibility = data.is_switch_visibility; // 承認判定用（読み込み時点のステータスと依頼元教員名）

      this.originalStatus = data.message.status;
      this.requesterName = data.teacher ? data.teacher.name : ""; // メッセージ関連（ロード時は日本語でOK）

      this.message.subject = data.content.subject;
      this.message.mail_body = data.content.mail_body;
      this.message.call_body = data.content.call_body; // 添付ファイル

      if (data.message.attached_file) {
        this.s3_attached_path = this.message.attached_file = data.message.attached_file;
      } // 電話自動再配信設定


      this.message.settings = JSON.parse(data.message.settings);

      if (data.enquete) {
        this.message.useEnquete = true; // アンケートデータがある場合は、取得したデータを store にセットする
        // こっちもロード時は日本語で

        var questions_data = [];
        data.questions.forEach(function (v) {
          questions_data.push({
            subject: v.subject,
            options: v.options,
            type: v.type
          });
        });
        this.$store.dispatch("commitEnquete", {
          subject: data.enquete_contents.subject,
          implement_to: data.enquete.implement_to,
          questions: questions_data
        });
      }
    },
    selectTo: function selectTo() {
      this.showStudentSelectModal = true;
      this.confirmMode = false;
    },
    confirmTo: function confirmTo() {
      this.showStudentSelectModal = true;
      this.confirmMode = true;
    },
    finishSelectStudents: function finishSelectStudents() {
      this.showStudentSelectModal = false;
      this.confirmMode = false;
    },
    validateMessage: function validateMessage() {
      this.error = {
        sendTargets: null,
        subject: null,
        mail_body: null,
        call_body: null,
        enquete: null,
        total: []
      };
      var valid = true;

      if (!(this.message.sendTargets.students.length > 0 || this.message.sendTargets.participants.length > 0)) {
        var message = "送信先を指定してください。";
        this.error.sendTargets = message;
        this.error.total.push(message);
        valid = false;
      }

      if (!this.message.subject) {
        var _message = "メールの件名を入力してください。";
        this.error.subject = _message;
        this.error.total.push(_message);
        valid = false;
      }

      if (this.message.subject && this.message.subject.length > 100) {
        var _message2 = "メールの件名は100文字以内で入力してください";
        this.error.subject = _message2;
        this.error.total.push(_message2);
        valid = false;
      }

      if (!this.message.mail_body) {
        var _message3 = "メールのメッセージ本文を入力してください。";
        this.error.mail_body = _message3;
        this.error.total.push(_message3);
        valid = false;
      }

      if (this.message.mail_body && this.message.mail_body.length > 3000) {
        var _message4 = "メールのメッセージ本文は3000文字以内で入力してください";
        this.error.mail_body = _message4;
        this.error.total.push(_message4);
        valid = false;
      }

      if (!this.message.call_body) {
        var _message5 = "電話のメッセージ本文を入力してください。";
        this.error.call_body = _message5;
        this.error.total.push(_message5);
        valid = false;
      }

      if (this.message.call_body && this.message.call_body.length > 200) {
        var _message6 = "電話のメッセージ本文は200文字以内で入力してください";
        this.error.call_body = _message6;
        this.error.total.push(_message6);
        valid = false;
      }

      if (this.message.useEnquete) {
        if (!this.enquete.subject) {
          var _message7 = "アンケートの名前を入力してください。";
          this.error.enquete = _message7;
          this.error.total.push(_message7);
          valid = false;
        }

        if (this.enquete.questions.find(function (v) {
          //質問のタイトルが無い、あるいは設問に空っぽがある
          return !v.subject || v.type === "single" && v.options.find(function (v2) {
            return !v2;
          }) !== undefined || v.type === "single" && v.options.length <= 1;
        })) {
          var _message8 = "質問と回答を入力してください。選択式の場合は回答を２つ以上入力してください。";
          this.error.enquete = _message8;
          this.error.total.push(_message8);
          valid = false;
        }
      }

      return valid;
    },
    saveMessage: function saveMessage(actionMode) {
      var _this2 = this;

      this.showPreviewModal = false;

      if (!this.validateMessage()) {
        return false;
      }

      this.message.status = actionMode;

      if (actionMode === "reserved") {
        this.message.status = "reserved";
        this.loadingMessage = "お知らせの送信予約をしています。";
      } else if (actionMode === "requestApproval") {
        this.message.status = "reviewing";
        this.loadingMessage = "承認依頼を管理者の先生方に送信しています。";
      } else if (actionMode === "approve") {
        this.message.status = "reserved";
        this.loadingMessage = "お知らせを承認しています。";
      } else if (actionMode === "reject") {
        this.message.status = "draft";
        this.loadingMessage = "お知らせを差し戻しています。";
      } else {
        this.message.status = "draft";
        this.loadingMessage = "お知らせの下書き保存をしています。";
      }

      this.isLoading.postData = true;
      var data = {
        messageInputs: this.message,
        enqueteInputs: this.enquete,
        requestApproval: actionMode === "requestApproval"
      };
      return new Promise(function (resolve, reject) {
        // attachment があるときだけ
        if (_this2.message.attachment) {
          // 添付ファイル作成
          var formData = new FormData();
          formData.append("attachment", _this2.message.attachment);
          createData("writer/save_attachment", formData).then(function (data) {
            _this2.message.attached_file = data.message.filepath;
          }).then(function () {
            return resolve();
          }).catch(function () {
            return reject();
          });
        } else {
          resolve();
        }
      }).then(function () {
        return new Promise(function (resolve, reject) {
          if (_this2.id) {
            updateData("writer/write_message/" + _this2.id, data).then(function () {
              return resolve();
            }).catch(function () {
              return reject();
            });
          } else {
            createData("writer/write_message", data).then(function () {
              return resolve();
            }).catch(function () {
              return reject();
            });
          }
        });
      }).then(function () {
        _this2.showCompleteMessage(actionMode);
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this2.isLoading.postData = false;
      });
    },
    showCompleteMessage: function showCompleteMessage(actionMode) {
      if (actionMode === "reserved") {
        this.$store.dispatch("commitModalMessage", {
          message: "お知らせの送信予約が完了しました",
          title: "予約完了"
        });
      } else if (actionMode === "requestApproval") {
        this.$store.dispatch("commitModalMessage", {
          message: "管理者の先生方に承認依頼を送信しました",
          title: "承認依頼完了"
        });
      } else if (actionMode === "approve") {
        this.$store.dispatch("commitModalMessage", {
          message: "お知らせを承認しました",
          title: "承認完了"
        });
      } else if (actionMode === "reject") {
        this.$store.dispatch("commitModalMessage", {
          message: "お知らせを差し戻しました",
          title: "差し戻し完了"
        });
      } else {
        this.$store.dispatch("commitModalMessage", {
          message: "下書きとして保存しました",
          title: "下書き保存完了"
        });
      }

      this.showCompleteModal = true;
    },
    completeCreate: function completeCreate() {
      this.showCompleteModal = false;
      this.$router.push({
        name: "messages"
      });
    },
    showAlreadyProcessedModal: function showAlreadyProcessedModal(status) {
      if (status === "reserved" || status === "published") {
        this.$store.dispatch("commitModalMessage", {
          message: "このお知らせは他の管理者の先生により既に承認され、送信予約または送信済みです。",
          title: "承認済み"
        });
      } else {
        this.$store.dispatch("commitModalMessage", {
          message: "このお知らせの承認依頼は解除されています。管理者の先生か作成者の先生自身が差し戻しました。",
          title: "差し戻し済み"
        });
      }

      this.showCompleteModal = true;
    },
    showConfirmMessage: function showConfirmMessage(target) {
      this.targetFunction = target;

      switch (target) {
        case "setTemplate":
          this.confirmMessageTitle = "定型文呼び出し";
          this.confirmMessage = "定型文を呼び出すと、今まで編集していた内容は失われます。\n（予約時間や送信先は残ります）\n実行してもよろしいですか？";
          break;

        case "clearTarget":
          this.confirmMessageTitle = "選択解除";
          this.confirmMessage = "送信先をクリアします。\nよろしいですか？";
          break;

        case "unsetS3Attachment":
          this.confirmMessageTitle = "ファイル差し替え";
          this.confirmMessage = "ファイルを差し替えると、現在添付されているファイルは確認できなくなります。\n実行してもよろしいですか？";
          break;
      }

      this.showConfirmModal = true;
    },
    callFunction: function callFunction() {
      switch (this.targetFunction) {
        case "setTemplate":
          this.setTemplate();
          break;

        case "clearTarget":
          this.clearTarget();
          break;

        case "unsetS3Attachment":
          this.unsetS3Attachment();
          break;
      }

      this.showConfirmModal = false;
    },
    cancelConfirm: function cancelConfirm() {
      this.showConfirmModal = false;
    },
    cancelPreview: function cancelPreview() {
      this.showPreviewModal = false;
      this.approvalModeActive = false;
    },
    setTemplate: function setTemplate() {
      var template = this.messageTemplates[this.message.template];
      this.message.subject = template.subject;
      this.message.mail_body = template.mail_body;
      this.message.call_body = template.call_body;

      if (!this.message.settings) {
        this.message.settings = {
          auto_redial: {
            use: false,
            interval: 15,
            iteration: 1
          }
        };
      }
    },
    clearTarget: function clearTarget() {
      this.message.sendTargets = {
        students: [],
        participants: []
      };
    },
    setAttachment: function setAttachment(e) {
      e.preventDefault();
      var files = e.target.files;

      if (this.checkFile(files[0])) {
        this.message.attachment = files[0];
      }
    },
    checkFile: function checkFile(file) {
      if (!file) return false; //拡張子はpdf, jpg, jpeg, png, gif

      var fileName = file.name;

      if (!(fileName.endsWith(".pdf") || fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png") || fileName.endsWith(".gif"))) {
        this.error.attachment = "ファイルの種類が不正です。添付できるファイルの種類はpdf, jpg, jpeg, png, gifです。";
        return false;
      } //サイズは5MBまで


      if (file.size > 5242880) {
        this.error.attachment = "ファイルサイズが5MBを超えています。添付できるファイルのサイズは5MB以下です。";
        return false;
      }

      return true;
    },
    // input type=file 側の unset
    unsetAttachment: function unsetAttachment() {
      document.getElementById("file").value = "";
      this.message.attachment = false;
    },
    // s3 パスの unset
    unsetS3Attachment: function unsetS3Attachment() {
      this.s3_attached_path = false;
    },
    // 管理画面閲覧用の署名付きURLを取得
    getS3SignedUrl: function getS3SignedUrl() {
      var _this3 = this;

      this.getS3UrlStatus = "お待ち下さい";
      this.getS3UrlStatusRunning = true; //secure browserのpopup block 対策

      var newWindow = window.open();
      getData("reader/get_s3_signed_url?path=" + encodeURIComponent(this.s3_attached_path)).then(function (data) {
        newWindow.location = data.items.s3url;
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this3.getS3UrlStatus = "内容を確認";
        _this3.getS3UrlStatusRunning = false;
      });
    },
    handleInputMailBody: function handleInputMailBody() {
      //まだ電話未入力であればコピーしてあげる
      if (!this.callBodyInput) {
        this.message.call_body = this.message.mail_body;
      }
    },
    detectCallBodyInput: function detectCallBodyInput() {
      this.callBodyInput = true;
    },
    openPreviewModal: function openPreviewModal(processReviewing) {
      this.showPreviewModal = true;
      this.processReviewing = processReviewing === true ? true : false;
      this.approvalModeActive = false;
    },
    openApprovalModal: function openApprovalModal() {
      this.showPreviewModal = true;
      this.processReviewing = false;
      this.approvalModeActive = true;
    },
    setMessageVisibility: function setMessageVisibility(mode) {
      this.message.visibility = mode;
    }
  }
};
import { ref, toRefs } from "vue";
import { useMessageUrlValidator } from "@/composables/messageUrlValidator";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var message = ref({
      is_emergency: 0,
      template: false,
      sendTargets: {
        students: [],
        participants: []
      },
      subject: null,
      mail_body: null,
      call_body: null,
      settings: {
        auto_redial: {
          use: false,
          interval: 15,
          iteration: 1
        }
      },
      message_scheduled_for: moment().format("YYYY-MM-DD HH:mm:00"),
      expire_on: moment().add(9, "month").year() + "-05-31",
      useEnquete: false,
      enquete: [],
      attachment: false,
      attached_file: null,
      status: "draft",
      visibility: "default"
    });

    var _toRefs = toRefs(message.value),
        mail_body = _toRefs.mail_body;

    var _useMessageUrlValidat = useMessageUrlValidator(mail_body),
        isUrlValidate = _useMessageUrlValidat.isUrlValidate;

    var today = moment().format("YYYY-MM-DD");
    var threeYearsLater = moment().add(3, "year").format("YYYY-MM-DD");
    expose({
      message: message
    });
    return {
      __sfc: true,
      message: message,
      mail_body: mail_body,
      isUrlValidate: isUrlValidate,
      today: today,
      threeYearsLater: threeYearsLater,
      MessageModal: MessageModal,
      StudentSelector: StudentSelector,
      PreviewModal: PreviewModal,
      InputEnquete: InputEnquete,
      LoadingMessage: LoadingMessage,
      ConfirmModal: ConfirmModal,
      RowItem: RowItem
    };
  }
});